import AntecipacaoRecebiceisInterceptor from '@finx/web-repository/src/apis/AntecipacaoRecebiveis/AntecipacaoRecebiveisInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'

const factory = new FactoryResponse()
const api = new AntecipacaoRecebiceisInterceptor()

export default {
  async getAllAntecipacoes(params: any) {
    let query = '&paginar=true'

    if (params.pagina) query += `&pagina=${params.pagina}`
    if (params.qtdPorPagina) query += `&qtdPorPagina=${params.qtdPorPagina}`
    if (params.situacao || params.situacao === 0) query += `&situacao=${params.situacao}`
    if (params.profissional) query += `&profissional=${params.profissional}`
    if (params.hospital) query += `&hospital=${params.hospital}`
    if (params.proxPagamentoInicio) query += `&proximoPagamentoInicio=${params.proxPagamentoInicio}`
    if (params.proxPagamentoFim) query += `&proximoPagamentoFim=${params.proxPagamentoFim}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''
    const request = await api.get(`antecipacoes${query}`)
    return factory.build(request)
  },

  async getAntecipacaoById(params: any) {
    const request = await api.get(`antecipacoes/${params.id}`)
    return factory.build(request)
  },

  async atualizarAntecipacao(params: any) {
    const request = await api.put(`antecipacoes/${params.id}`, params)
    return factory.build(request)
  },

  async getDadosBancarios(params: any) {
    const request = await api.get(`dados-bancario/obter-por-empresa-medica/${params.id}`)
    return factory.build(request)
  },

  async atualizarDadosBancarios(params: any) {
    const request = await api.post('dados-bancario/upsert', params)
    return factory.build(request)
  },

  async getSituacoes() {
    const request = await api.get('antecipacoes/status')
    return factory.build(request)
  },

  async getBancos() {
    const request = await api.get('instituicoes-financeira')
    return factory.build(request)
  },

  async getTiposPix() {
    const request = await api.get('instituicoes-financeira/tipos-chave-pix')
    return factory.build(request)
  },

  async getAntecipacaoProfissional(documento: string) {
    const request = await api.get(`antecipacoes/obter-por-profissional/${documento}`)
    return factory.build(request)
  },

  async submitAntecipacaoProfissional(payload: any) {
    const request = await api.put(`antecipacoes/atualizar-antecipacao-profissional/${payload.antecipacaoId}`, payload)
    return factory.build(request)
  }
}